import type { ColumnFiltersState, ColumnOrderState, ColumnSizingState, SortingState, VisibilityState } from '@tanstack/react-table'

export interface GrowthTableState {
  sorting: SortingState
  columnFilters: ColumnFiltersState
  columnOrder: ColumnOrderState
  columnVisibility: VisibilityState
  columnSizing: ColumnSizingState
}

export interface GrowthExportView {
  row_indices: number[]
  columns: { id: string; width: number }[]
}

export function initialGrowthTableState(): GrowthTableState {
  return { sorting: [{ id: 'final_score', desc: true }], columnFilters: [], columnOrder: [],
    columnVisibility: { latest_post_date: false, activity_checked_at: false, activity_reason: false }, columnSizing: {} }
}

export function matchesColumnValue(value: unknown, query: string): boolean {
  const filter = query.trim().toLocaleLowerCase()
  if (!filter) return true
  if (typeof value === 'number') {
    const compare = filter.match(/^(>=|<=|>|<|=)\s*(-?\d+(?:\.\d+)?)$/)
    if (compare) {
      const number = Number(compare[2])
      return compare[1] === '>=' ? value >= number : compare[1] === '<=' ? value <= number
        : compare[1] === '>' ? value > number : compare[1] === '<' ? value < number : value === number
    }
    const range = filter.match(/^(-?\d+(?:\.\d+)?)\s*\.\.\s*(-?\d+(?:\.\d+)?)$/)
    if (range) return value >= Number(range[1]) && value <= Number(range[2])
  }
  return String(value ?? '').toLocaleLowerCase().includes(filter)
}

export function connectionLabel(value: unknown): string {
  const token = String(value ?? '').toUpperCase()
  for (const [number, label] of [[1, 'FIRST'], [2, 'SECOND'], [3, 'THIRD']] as const) {
    if (token === String(number) || token === `${label}_DEGREE` || token.startsWith(`${number}°`) || token.includes(`${number}${number === 1 ? 'ST' : number === 2 ? 'ND' : 'RD'}`)) return `${number}°`
  }
  return token
}
